export const reports = "/reports";
export const root = "/";
export const settings = "/settings";
export const goals = "/goals";
